import { nameList } from "@/permission";

const state = {
  shellConst: {}
};

const mutations = {
  SET_SHELLCONST: (state, shellConst) => {
    state.shellConst = shellConst;
  }
};

const actions = {
  setShellConst({ commit }, shellConst) {
    const hash = location.hash.split("?")[0];
    if (nameList.has(hash.replace(/#/g, ""))) {
      document.title = nameList.get(hash.replace(/#/g, ""));
    }
    if (shellConst && shellConst.websiteName && !nameList.has(hash.replace(/#/g, ""))) {
      document.title = shellConst.websiteName;
    }
    commit("SET_SHELLCONST", shellConst);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
